export function getMemberEnrollmentBlockReason(user, supportInfo) {
    if (user?.isMember) {
        return 'alreadyMember';
    }
    if (user?.isMemberToCustomer && !user?.allowMemberEnrollment) {
        return 'notAllowed';
    }
    if (!user?.allowMemberEnrollment && supportInfo != null && !supportInfo.isMemberEnrollmentAvailable) {
        return 'wait24Hours';
    }
    return null;
}

export function showMemberEnrollmentBlock(commonStore, t, reason) {
    if (reason === 'alreadyMember') {
        commonStore.showConfirm(
            t("Congratulations, you are already a Member"),
            "OK",
            t("Congratulations"),
            () => {},
            null
        );
        return;
    }
    if (reason === 'notAllowed') {
        commonStore.showConfirm(
            t("global:becomeAMemberNotAllowed"),
            "OK",
            t("global:becomeAMember"),
            () => {},
            null
        );
        return;
    }
    if (reason === 'wait24Hours') {
        commonStore.showConfirm(
            t("global:becomeAMember24HoursWait"),
            "OK",
            t("global:becomeAMember"),
            () => {},
            null
        );
    }
}
